const SignatureEmployee = () => {
	return <div>SignatureEmployee</div>;
};

export default SignatureEmployee;
